
import Index from "./Index.vue";
import SerialStart from "./SerialStart.vue";
import SerialConfirm from "./SerialConfirm.vue";
import SerialEnd from "./SerialEnd.vue";
import SerialMail from "./SerialMail.vue";
import RegistrationStart from "./RegistrationStart.vue";
import RegistrationConfirm from "./RegistrationConfirm.vue";
import Order from "./Order.vue";
import OrderConfirm from "./OrderConfirm.vue";
import Delivery from "./Delivery.vue";
import DeliveryConfirm from "./DeliveryConfirm.vue";
import DeliveryEnd from "./DeliveryEnd.vue";
import DeliveryMail from "./DeliveryMail.vue";

export default {
  routes: [
    {
      path: "/mock/influencer",
      component: Index,
    },
    {
      path: "/mock/influencer/serial",
      component: SerialStart,
    },
    {
      path: "/mock/influencer/serial/confirm",
      component: SerialConfirm,
    },
    {
      path: "/mock/influencer/serial/end",
      component: SerialEnd,
    },
    {
      path: "/mock/influencer/serial/mail",
      component: SerialMail,
    },
    {
      path: "/mock/influencer/registration",
      component: RegistrationStart,
    },
    {
      path: "/mock/influencer/registration/confirm",
      component: RegistrationConfirm,
    },
    {
      path: "/mock/influencer/order",
      component: Order,
    },
    {
      path: "/mock/influencer/order/confirm",
      component: OrderConfirm,
    },
    {
      path: "/mock/influencer/delivery",
      component: Delivery,
    },
    {
      path: "/mock/influencer/delivery/confirm",
      component: DeliveryConfirm,
    },
    {
      path: "/mock/influencer/delivery/end",
      component: DeliveryEnd,
    },
    {
      path: "/mock/influencer/delivery/mail",
      component: DeliveryMail,
    },
  ],
};
